import classnames from 'classnames';
import React from 'react';

function Text({ children, className }) {
    return (
        <p className={classnames([
            'kmx-typography',
            className
        ])}>{children}</p>
    )
}

Text.Display1 = ({ children, className }) => (
    <h3 className={classnames([
        'kmx-typography--display-1',
        className
    ])}>{children}</h3>
)

Text.Display2 = ({ children, className }) => (
    <h3 className={classnames([
        'kmx-typography--display-2',
        className
    ])}>{children}</h3>
)

Text.Display3 = ({ children, className }) => (
    <h3 className={classnames([
        'kmx-typography--display-3',
        className
    ])}>{children}</h3>
)

Text.Display4 = ({ children, className }) => (
    <h1 className={classnames([
        'kmx-typography--display-4',
        className
    ])}>{children}</h1>
)

Text.Display5 = ({ children, className }) => (
    <h1 className={classnames([
        'kmx-typography--display-5',
        className
    ])}>{children}</h1>
)

Text.Display6 = ({ children, className }) => (
    <h1 className={classnames([
        'kmx-typography--display-6',
        className
    ])}>{children}</h1>
)

Text.Headline1 = ({ children, className }) => (
    <h4 className={classnames([
        'kmx-typography--headline-1',
        className
    ])}>{children}</h4>
)

Text.Headline2 = ({ children, className }) => (
    <h4 className={classnames([
        'kmx-typography--headline-2',
        className
    ])}>{children}</h4>
)

Text.Headline3 = ({ children, className }) => (
    <h4 className={classnames([
        'kmx-typography--headline-3',
        className
    ])}>{children}</h4>
)

Text.Eyebrow = ({ children, className }) => (
	<h5 className={classnames([
		'kmx-typography--eyebrow',
		className
	])}>{children}</h5>
)

Text.Body1 = ({ children, className }) => (
    <p className={classnames([
        'kmx-typography--body-1',
        className
    ])}>{children}</p>
)

Text.Body2 = ({ children, className }) => (
    <p className={classnames([
        'kmx-typography--body-2',
        className
    ])}>{children}</p>
)

Text.Body3 = ({ children, className }) => (
    <p className={classnames([
        'kmx-typography--body-3',
        className
    ])}>{children}</p>
)

Text.FinePrint = ({ children, className }) => (
    <p className={classnames([
        'kmx-typography--fine-print',
        className
    ])}>{children}</p>
)

Text.Emphasis1 = ({ children, className }) => (
    <p className={classnames([
        'kmx-typography--emphasis-1',
        className
    ])}>{children}</p>
)

Text.Emphasis2 = ({ children, className }) => (
    <p className={classnames([
        'kmx-typography--emphasis-2',
        className
    ])}>{children}</p>
)

Text.Emphasis3 = ({ children, className }) => (
    <p className={classnames([
        'kmx-typography--emphasis-3',
        className
    ])}>{children}</p>
)

Text.Emphasis4 = ({ children, className }) => (
    <p className={classnames([
        'kmx-typography--emphasis-4',
        className
    ])}>{children}</p>
)

Text.LabelSmall = ({ children, className }) => (
    <p className={classnames([
        'kmx-typography--label-sm',
        className
    ])}>{children}</p>
)

Text.LabelLarge = ({ children, className }) => (
    <p className={classnames([
        'kmx-typography--label-lg',
        className
    ])}>{children}</p>
)

Text.Link = ({ children, className, onClick, to, ...props }) => (
    <a href={to} onClick={onClick} className={classnames([
        'kmx-typography--link',
        className
    ])}
        {...props}
    >{children}</a>
)

export default Text;